import { useMemo, useState } from 'react';
import { displayAddress } from '../../domain/inspection';
import { useT } from '../../i18n/i18n';
import { useStore } from '../../state/createStore';
import { dismissClearedDraftsNotice, draftRetentionStore, draftsNearCleanup, keepDraftsAction } from '../../state/draftRetention';
import { evidenceStore } from '../../state/evidenceStore';
import { findingStore } from '../../state/findingStore';
import { inspectionStore } from '../../state/inspectionStore';
import { Banner, Button } from '../../ui/components';

// Abandoned drafts (retention rules 2026-10-19): two weeks of warning with 「保留」, then a one-time notice
// of what was cleared. Nothing is cleared without the warning having been shown on this screen first.
export function DraftRetentionBanners() {
  const { t, tp } = useT();
  const inspections = useStore(inspectionStore, (s) => s);
  const findings = useStore(findingStore, (s) => s.findings);
  const evidence = useStore(evidenceStore, (s) => s.evidence);
  const cleared = useStore(draftRetentionStore, (s) => s.cleared);
  const [busy, setBusy] = useState(false);
  const near = useMemo(() => draftsNearCleanup(Date.now()), [inspections, findings, evidence, cleared]);
  const first = near.length > 0 ? inspections.inspections.find((i) => i.id === near[0].inspectionId) ?? null : null;

  async function keep() {
    setBusy(true);
    try {
      await keepDraftsAction(near.map((d) => d.inspectionId));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      {cleared.length > 0 ? (
        <div className="banner-slot">
          <Banner
            tone="info"
            icon="info"
            title={tp('drafts.clearedTitle', cleared.length)}
            body={t('drafts.clearedBody', { list: cleared.map((c) => (c.address.length > 0 ? c.address : t('drafts.noAddress'))).join('、') })}
            action={
              <Button variant="text" onClick={() => dismissClearedDraftsNotice()} testId="drafts-cleared-dismiss">
                {t('drafts.dismiss')}
              </Button>
            }
            testId="drafts-cleared"
          />
        </div>
      ) : null}
      {near.length > 0 && first ? (
        <div className="banner-slot">
          <Banner
            tone="warning"
            icon="schedule"
            title={tp('drafts.nearTitle', near.length)}
            body={tp('drafts.nearBody', near[0].daysLeft, { address: displayAddress(first, t('drafts.noAddress')) })}
            action={
              <Button variant="secondary" onClick={() => void keep()} disabled={busy} testId="drafts-keep">
                {t('drafts.keep')}
              </Button>
            }
            testId="drafts-near"
          />
        </div>
      ) : null}
    </>
  );
}
